export const ages = [
	{ id: '18-24' },
	{ id: '25-34' },
	{ id: '35-44' },
	{ id: '45-64' },
	{ id: '65+' }
];

export const alcohol_use_frequencies = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Daily' },
	{ id: 'Weekly' },
	{ id: 'Occasionally' },
	{ id: 'Never' }
];

export const allergy_types = [
	{ id: null, label: 'Unspecified' },
	{ id: 'Food' },
	{ id: 'Medication' },
	{ id: 'Environmental' }
];

export const best_days_to_call = [
	{ id: 'M', label: 'Monday' },
	{ id: 'T', label: 'Tuesday' },
	{ id: 'W', label: 'Wednesday' },
	{ id: 'R', label: 'Thursday' },
	{ id: 'F', label: 'Friday' },
	{ id: 'S', label: 'Saturday' },
	{ id: 'Y', label: 'Sunday' }
];

export const condition_statuses = [
	{ id: 'Active' },
	{ id: 'Resolved' },
	{ id: 'Managed' },
	{ id: 'Unresolved' }
];

export const diet_types = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Vegetarian' },
	{ id: 'Vegan' },
	{ id: 'Omnivore' },
	{ id: 'Pescatarian' },
	{ id: 'Other' }
];

export const ethnicities = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Hispanic or Latino' },
	{ id: 'Not Hispanic or Latino' }
];

export const family_members = [
	{ id: 'Mother' },
	{ id: 'Father' },
	{ id: 'Sibling' },
	{ id: 'Grandparent' },
	{ id: 'Other' }
];

export const genders = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Male' },
	{ id: 'Female' },
	{ id: 'Non-binary' },
	{ id: 'Other' }
];

export const languages = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'English' },
	{ id: 'Spanish' },
	{ id: 'Other' }
];

export const marital_statuses = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Married' },
	{ id: 'Single' },
	{ id: 'Widow(er)' }
];

export const phone_types = [
	{ id: 'Mobile' },
	{ id: 'Home' },
	{ id: 'Work' },
	{ id: 'Other' }
];

export const physical_activity_levels = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Sedentary' },
	{ id: 'Moderate' },
	{ id: 'Active' },
	{ id: 'Very Active' }
];

export const races = [
	{ id: null, label: 'Prefer not to say' },
    { id: 'African American' },
	{ id: 'African-American' },
	{ id: 'American-Indian' },
	{ id: 'Asian' },
	{ id: 'Asian or Pacific Islander' },
	{ id: 'Black, not of Hispanic Or' },
	{ id: 'Caucasian' },
	{ id: 'Chinese' },
	{ id: 'East Indian' },
	{ id: 'Filipino' },
	{ id: 'Hispanic' },
	{ id: 'Japanese' },
	{ id: 'Multiracial' },
	{ id: 'Native Alaskan' },
	{ id: 'Native American' },
	{ id: 'Native Hawaiian' },
	{ id: 'Other' },
	{ id: 'Unclassified' },
	{ id: 'Unknown' },
	{ id: 'White' },
	{ id: 'White, not of Hispanic Or' }
];

export const severities = [
  { id: null, label: 'Unspecified' },
  { id: 'Mild', label: 'Mild' },
  { id: 'Moderate', label: 'Moderate' },
  { id: 'Severe', label: 'Severe' }
];


export const smoker_statuses = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Smoker' },
	{ id: 'Non-Smoker' },
	{ id: 'Former Smoker' }
];

export const states = [
	{ "id": "AL", "label": "Alabama" },
	{ "id": "AK", "label": "Alaska" },
	{ "id": "AZ", "label": "Arizona" },
	{ "id": "AR", "label": "Arkansas" },
	{ "id": "CA", "label": "California" },
	{ "id": "CO", "label": "Colorado" },
	{ "id": "CT", "label": "Connecticut" },
	{ "id": "DE", "label": "Delaware" },
	{ "id": "FL", "label": "Florida" },
	{ "id": "GA", "label": "Georgia" },
	{ "id": "HI", "label": "Hawaii" },
	{ "id": "ID", "label": "Idaho" },
	{ "id": "IL", "label": "Illinois" },
	{ "id": "IN", "label": "Indiana" },
	{ "id": "IA", "label": "Iowa" },
	{ "id": "KS", "label": "Kansas" },
	{ "id": "KY", "label": "Kentucky" },
	{ "id": "LA", "label": "Louisiana" },
	{ "id": "ME", "label": "Maine" },
	{ "id": "MD", "label": "Maryland" },
	{ "id": "MA", "label": "Massachusetts" },
	{ "id": "MI", "label": "Michigan" },
	{ "id": "MN", "label": "Minnesota" },
	{ "id": "MS", "label": "Mississippi" },
	{ "id": "MO", "label": "Missouri" },
	{ "id": "MT", "label": "Montana" },
	{ "id": "NE", "label": "Nebraska" },
	{ "id": "NV", "label": "Nevada" },
	{ "id": "NH", "label": "New Hampshire" },
	{ "id": "NJ", "label": "New Jersey" },
	{ "id": "NM", "label": "New Mexico" },
	{ "id": "NY", "label": "New York" },
	{ "id": "NC", "label": "North Carolina" },
	{ "id": "ND", "label": "North Dakota" },
	{ "id": "OH", "label": "Ohio" },
	{ "id": "OK", "label": "Oklahoma" },
	{ "id": "OR", "label": "Oregon" },
	{ "id": "PA", "label": "Pennsylvania" },
	{ "id": "RI", "label": "Rhode Island" },
	{ "id": "SC", "label": "South Carolina" },
	{ "id": "SD", "label": "South Dakota" },
	{ "id": "TN", "label": "Tennessee" },
	{ "id": "TX", "label": "Texas" },
	{ "id": "UT", "label": "Utah" },
	{ "id": "VT", "label": "Vermont" },
	{ "id": "VA", "label": "Virginia" },
	{ "id": "WA", "label": "Washington" },
	{ "id": "WV", "label": "West Virginia" },
	{ "id": "WI", "label": "Wisconsin" },
	{ "id": "WY", "label": "Wyoming" }
];

export const stress_levels = [
	{ id: null, label: 'Prefer not to say' },
	{ id: 'Low' },
	{ id: 'Moderate' },
	{ id: 'High' },
	{ id: 'Very High' }
];

export const titles = [
  { id: "Mr", label: "Mr - A standard title for adult men, regardless of marital status." },
  { id: "Mrs", label: "Mrs - A title for married women." },
  { id: "Ms", label: "Ms - A neutral title for women, not indicating marital status." },
  { id: "Miss", label: "Miss - A title for unmarried women or girls." },
  { id: "Dr", label: "Dr - Used for individuals with a doctorate degree or medical qualification." },
  { id: "Prof", label: "Prof - Short for 'Professor,' used for academic professionals." },
  { id: "Rev", label: "Rev - Short for 'Reverend,' used for members of the clergy." },
  { id: "Hon", label: "Hon - Short for 'The Honorable,' used for judges, elected officials, or dignitaries." },
  { id: "Sir", label: "Sir - A formal title granted by knighthood, used for men." },
  { id: "Lady", label: "Lady - A formal title for women with nobility or as a counterpart to 'Sir.'" },
  { id: "Capt", label: "Capt - Short for 'Captain,' a rank in the military, navy, or aviation." },
  { id: "Col", label: "Col - Short for 'Colonel,' a senior military rank." },
  { id: "Maj", label: "Maj - Short for 'Major,' a mid-senior military rank." },
  { id: "Lt", label: "Lt - Short for 'Lieutenant,' a junior military rank." },
  { id: "Adm", label: "Adm - Short for 'Admiral,' a high-ranking naval officer." },
  { id: "Gen", label: "Gen - Short for 'General,' a high-ranking officer in the army or air force." },
  { id: "Mx", label: "Mx - A gender-neutral title used for individuals who prefer not to specify gender." }
];
